export default function(element, callback) {
  element.style.position = 'relative'
  element.style.transition = `opacity 0.5s linear`
  element.style.opacity = 0
  setTimeout(() => {
    element.remove()
    typeof callback === 'function' && callback()
  }, 500)
}
